"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCustomizationMode = isCustomizationMode;
exports.isThemeType = isThemeType;

/**
 * Checks if the user is currently in customization mode.
 * Customization mode is activated when the URL contains the 'customize' query parameter.
 *
 * @returns {boolean} True if in customization mode, false otherwise
 */
function isCustomizationMode() {
  return typeof window !== 'undefined' && window.location.search.includes('customize');
}
/**
 * Types of theme configurator tabs available
 */


/**
 * Type guard to check if a string is a valid ThemeType
 *
 * @param type - The string to check
 * @returns True if the type is a valid ThemeType
 */
function isThemeType(type) {
  if (!type) return false;
  return ['color', 'button', 'font', 'card', 'customCss', 'branding'].includes(type);
}
/**
 * Available page types that can be customized
 */